import { useQuery } from '@hooks/reactQuery';

import { getNetworkElementsConnectionStatuses } from '@api/networkElements';

import { extractQueryParams } from '@utils/common';
import { actionsFormatted } from '@utils/formatter';

import { TSelectOption } from '@interfaces/components/componentTypes';

import { refetchOptions } from '@constants/common';
import { NETWORK_ELEMENTS_CONNECTION_OPTIONS } from '@constants/queryKeys';

interface IUseQueryNetworkElementsConnectionsReturned {
	connectionOptions: TSelectOption[];
	isLoadingConnectionOptions: boolean;
}

const useQueryNetworkElementsConnections = (): IUseQueryNetworkElementsConnectionsReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery({
		queryKey: [NETWORK_ELEMENTS_CONNECTION_OPTIONS],
		select: actionsFormatted,
		queryFn: extractQueryParams(getNetworkElementsConnectionStatuses),
		...refetchOptions,
	});

	return {
		connectionOptions: data || [],
		isLoadingConnectionOptions: (isLoading && !!data)
			|| isFetching,
	};
};

export default useQueryNetworkElementsConnections;
